"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_observable_1 = require("redux-observable");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const typescript_fsa_1 = __importDefault(require("typescript-fsa"));
const sandbox_1 = require("../sandbox");
const reducerWithImmer_1 = require("./reducerWithImmer");
exports.initialState = {
    instance: new sandbox_1.Sandbox(),
    /**
     * 最後に自分がファイルを書き換えた時の version の値
     */
    localVersion: 0,
    /**
     * Sandbox が最後に実行した version の値
     */
    runningVersion: 0,
    /**
     * 自分または誰かがファイルが変更した時に 1 ずつ増加するバージョン
     */
    version: 0
};
const actionCreator = typescript_fsa_1.default('gamebook');
exports.actions = {
    incrementVersion: actionCreator('INCREMENT_VERSION'),
    runSanbox: actionCreator('RUN_SANDBOX'),
    writeFiles: actionCreator('WRITE_FILES')
};
const sandbox = reducerWithImmer_1.reducerWithImmer(exports.initialState)
    .case(exports.actions.incrementVersion, draft => {
    draft.version += 1;
})
    .case(exports.actions.runSanbox, draft => {
    draft.runningVersion = draft.version;
})
    .case(exports.actions.writeFiles, draft => {
    draft.version += 1;
    draft.localVersion = draft.version;
})
    .toReducer();
exports.default = sandbox;
exports.reducers = {
    sandbox
};
exports.epic = redux_observable_1.combineEpics((action$, store$) => action$.pipe(operators_1.filter(exports.actions.writeFiles.match), operators_1.tap(action => {
    store$.value.sandbox.instance.update(action.payload);
}), operators_1.mergeMap(() => rxjs_1.NEVER)), (action$, store$) => store$.pipe(operators_1.map(state => state.sandbox.runningVersion), operators_1.filter(v => v > 0), operators_1.distinctUntilChanged(), operators_1.tap(() => {
    store$.value.sandbox.instance.run();
}), operators_1.mergeMap(() => rxjs_1.NEVER)));
